import { Injectable } from "@angular/core";
import { GlobalService } from "./global.service";
import { RecipientRole } from "app/main/pages/edit-template/edit-template.dto";
import { SelectedRole } from "app/main/pages/general-editor-tabs/general-popover-settings/general-popover-settings.dto";
import { EditorEmitterService } from "app/main/pages/events/editor-emitter.service";
import { TemplateType } from "app/main/pages/templates/template.dto";

@Injectable({
    providedIn: 'root'
})

export class SetDefaultRecipientRoleFieldService {
    constructor(
        private globalService: GlobalService,
        private editorEmitterService: EditorEmitterService
    ) { }

    /**
     * Sets the default recipient role field for a given field UUID.
     * 
     * If no role exists or the `setDefault` flag is true, assigns the field to a default "Sender" role.
     * Otherwise, assigns the field to the first available role.
     * 
     * @param uuid - The unique identifier of the signature to assign.
     * @param setDefault - Optional flag to force assignment to the default "Sender" role. Defaults to `false`.
     * @returns An object containing the selected role ID and recipient ID.
     */
    setDefaultRecipientRoleField(uuid, setDefault: boolean = false) {
        const isEform = this.editorEmitterService.currentTemplateType$.getValue() === TemplateType.EFORM;
        const role = this.globalService.roles[0];
        if (!role || (setDefault && !isEform)) {
            const senderRole: SelectedRole = { id: 0, name: 'Sender', recipient: undefined, recipient_id: 0 };
            const result = this.globalService.assignSignatureToRole(senderRole, uuid);
            return { selected_for_role_id: 0, recipient_id: undefined, ...result };
        }
        const selectedRole = this.getTheRoleObject(role);
        const result = this.globalService.assignSignatureToRole(selectedRole, uuid);
        return { selected_for_role_id: role.id, recipient_id: role.recipient_id, ...result };
    }

    getTheRoleObject(role: RecipientRole): SelectedRole {
        return {
            id: role.id,
            name: role.role_name,
            color: role.role_color,
            recipient: (role.recipient_id ? `${role.recipient.firstname} ${role.recipient.lastname ?? ''}` : ''),
            recipient_id: role.recipient_id
        }
    }
}